// extracted by mini-css-extract-plugin
export default {"learn-more":"Button_learn-more__zVOjd","button":"Button_button__6d0Ru","submit-button":"Button_submit-button__lp9l6"};